import { render, staticRenderFns } from "./AdjustmentsDetails.vue?vue&type=template&id=e6903f9a"
import script from "./AdjustmentsDetails.vue?vue&type=script&lang=js"
export * from "./AdjustmentsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports